<template>
    <div>
        <el-dialog class="restart-private" :visible.sync="show" :title="$t('operations.restart.name')" width="30%"
            :close-on-click-modal="false" :before-close="handleClose">
            <p>{{ $t('game.list.restartTip', [name]) }}</p>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelRestart">{{ $t('privateNetInstance.cancel') }}</el-button>
                <el-button @click="sureRestart" type="primary">{{ $t('privateNetInstance.sure') }}</el-button>
            </div>
        </el-dialog>
        <jcb-opt-protect :visible.sync="operationProtectVisible" :action-type="OperationConstant.RESTART"
            @success="onSuccess" @error="onError">
        </jcb-opt-protect>
    </div>
</template>

<script>
import operationProtect from '@/mixins/operationProject';
import { OperationConstant } from '@/common/Constants';
export default {
    name: "Restart",
    mixins: [operationProtect],

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        instanceId: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        region: {
            type: String,
            default: ''
        },
        rowInfo: {
            type: Object,
            default: () => { }
        },
        pageSource: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            show: false
        }
    },
    computed: {
        OperationConstant: () => OperationConstant
    },
    methods: {
        handleClose() {
            this.show = false;
            this.$emit('update:visible', false);
        },
        cancelRestart() {
            this.handleClose();
        },
        sureRestart() {
            this.rowInfo.instanceType = "game";
            this.openOperationProtect(OperationConstant.RESTART, this.rowInfo, this.pageSource);
            this.handleClose();
        },
        restartInstance(headers) {
            const params = {
                instanceId: this.rowInfo.instanceId,
                region: this.region,
                clientToken: Normal.getClientToken(),
            };
            Ajax.put('/api/cps/restartInstance', params, { headers })
                .then()
                .catch()
                .finally(() => {
                    this.handleClose();
                    this.$emit('refresh')
                });
        }
    },
    watch: {
        visible(newVal) {
            this.show = newVal;
        }
    }
}
</script>

<style lang="scss">
.restart-private {}
</style>




// WEBPACK FOOTER //
// src/components/game/Restart.vue